import { render, staticRenderFns } from "./TopUpAccountDialog.vue?vue&type=template&id=40ccd3e4&scoped=true&"
import script from "./TopUpAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./TopUpAccountDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccd3e4",
  null
  
)

export default component.exports